// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {sync} from 'vuex-router-sync'

import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import VueJWT from 'vuejs-jwt'
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'
import VueIntro from 'vue-introjs'
import VTooltip from 'v-tooltip'
import VueCookie from 'vue-cookie'
import VueIntercom from 'vue-intercom'
import MicrobaResults from '@microbadevs/report'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

import store from '@/stores/'

import Bus from '@/event'

import VueD3 from 'vue-d3'
import 'intro.js/introjs.css'
import VueTelInput from 'vue-tel-input'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      dsn: 'https://59eea361df484966a6764155555aa734@sentry.io/1528838',
      integrations: [new Integrations.Vue({
        Vue,
        attachProps: true
      })],
      release: `c${process.env.APP_VERSION_CUSTOMER}-r${process.env.APP_VERSION_RESEARCH}`,
      environment: process.env.APP_ENVIRONMENT
    })
  } catch (error) {
    console.log(error)
  }
}
Vue.use(MicrobaResults)
Vue.use(VueScrollTo)
Vue.use(VueD3)
Vue.use(VueObserveVisibility)
Vue.use(Bus)
Vue.use(BootstrapVue)
Vue.use(VeeValidate)
Vue.use(VueJWT, {})
Vue.use(VueIntro)
Vue.use(VTooltip)
Vue.use(VueCookie)
Vue.use(VueIntercom, {appId: process.env.INTERCOM_KEY})
Vue.use(VueTelInput)

// Tell Vue to use the plugin
Vue.config.productionTip = false
Vue.prototype.$appName = 'Microba'

sync(store, router)

// Raven
// .config('https://162dc0c8b7284be6acf093a00f321481@sentry.io/1233290')
// .addPlugin(RavenVue, Vue)
// .install()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js